<template lang="html">
  <div class="about">
    <div class="page-help about-wrapper ">
      <div class="about-head">
        <h1>{{ $t("newHome.about.title") }}</h1>
        <div v-html="$t('newHome.about.headText')"></div>
      </div>
      <div class="about-main">
        <aboutWhy />
      </div>
    </div>
  </div>
</template>

<script>
import aboutWhy from "@/components/about/aboutWhy.vue";
import eventBus from "@/shared/eventBus.js";
export default {
  components: {
    aboutWhy
  },
  methods: {
    openModal() {
      eventBus.$emit("openModal", { component: "imgSolution" });
    }
  }
};
</script>

<style lang="scss" scoped>
.about {
  background-color: $gray-blue-400;
  font-family: Outfit;
  width: 100%;

  text-align: left;
  padding-top: 123px;
  padding-bottom: 123px;
  .about-wrapper {
    box-sizing: border-box;
    justify-content: center;

    .about-head {
      h1 {
        width: 554;
        height: 45;
        top: 123px;
        left: 290px;
        angle: 0 deg;
        opacity: 1;
        gap: 28px;
        color: $blue-1000;
        margin: 0;
        margin-bottom: 51px;
      }
      div {
        text-align: left;
        max-width: 607px;
        font-weight: 500;
        font-style: Medium;
        font-size: 20px;
        line-height: 30px;
        letter-spacing: 0%;
        color: $blue-400;
      }
    }
    .about-main {
      margin-top: 50px;
      text-align: left;
    }
  }
}
@media only screen and (max-width: 768px) {
  .about {
    padding-top: 50px;
    padding-bottom: 50px;
  }
}
</style>
